module.exports = __webpack_public_path__ + "img/anxiety-icon-3.4ca764c9.svg";